import { render, staticRenderFns } from "./UniversalForm.vue?vue&type=template&id=73472413&"
import script from "./UniversalForm.vue?vue&type=script&lang=js&"
export * from "./UniversalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports